import { render, staticRenderFns } from "./forgetPasswordBar.vue?vue&type=template&id=4e06fbb4&scoped=true&"
import script from "./forgetPasswordBar.vue?vue&type=script&lang=ts&"
export * from "./forgetPasswordBar.vue?vue&type=script&lang=ts&"
import style0 from "./forgetPasswordBar.vue?vue&type=style&index=0&id=4e06fbb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06fbb4",
  null
  
)

export default component.exports